// @flow
import {
    Consumer,
    Content,
    ControlPanel,
    ControlPanelIcon,
    ControlPanelToggleButton,
    Details,
    IconsContainer,
    Overlay,
    OverlayContent,
    Producer,
    ProductDeviceIcon,
    ProductIcon,
    RecipeItem,
    Text
} from './style';
import { EDIT, NOTIFICATIONS_ON, SCHEDULE, TRASH } from '~/core/constants/icons/general';
import { getThenConsumerText, getThenNotificationText, getWhenText } from '../common';
import { injectIntl, intlShape } from 'react-intl';

import { Button } from '~/components/widgets';
import ImmutablePropTypes from 'react-immutable-proptypes';
import messages from '../intl';
import PropTypes from 'prop-types';
import * as React from 'react';
import { recipeStatus } from '~/core/constants/recipes';
import ToggleButton from '~/components/widgets/buttons/toggle';

RecipesItem.propTypes = {
    cancelAction: PropTypes.func.isRequired,
    confirmDelete: PropTypes.func.isRequired,
    consumer: PropTypes.shape({
        duration: PropTypes.number,
        name: PropTypes.string.isRequired,
        state: PropTypes.any.isRequired,
        type: PropTypes.string.isRequired
    }),
    deleteRecipe: PropTypes.func.isRequired,
    editRecipe: PropTypes.func.isRequired,
    intl: intlShape,
    isEnabled: PropTypes.bool.isRequired,
    isScheduled: PropTypes.bool.isRequired,
    notificationOptions: ImmutablePropTypes.map,
    producer: PropTypes.shape({
        name: PropTypes.string.isRequired,
        trigger: PropTypes.string,
        type: PropTypes.string.isRequired
    }).isRequired,
    showSchedule: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    toggleRecipeStatus: PropTypes.func.isRequired
};

function RecipesItem({
    cancelAction,
    confirmDelete,
    consumer,
    deleteRecipe,
    editRecipe,
    intl: { formatMessage },
    isEnabled,
    isScheduled,
    notificationOptions,
    producer,
    toggleRecipeStatus,
    showSchedule,
    status
}) {
    const whenText = getWhenText(formatMessage, producer);
    const thenText = notificationOptions
        ? getThenNotificationText(formatMessage, notificationOptions)
        : getThenConsumerText(formatMessage, consumer);

    const { UPDATING, CONFIRMING, DELETING } = recipeStatus;
    return (
        <RecipeItem>
            <Content>
                <IconsContainer>
                    <Producer isEnabled={isEnabled}>
                        <ProductDeviceIcon active type={producer.type} />
                    </Producer>
                    <Consumer isEnabled={isEnabled}>
                        {consumer ? (
                            <ProductDeviceIcon active={consumer.isActive} type={consumer.type} />
                        ) : (
                            <ProductIcon icon={NOTIFICATIONS_ON} set={'general'} />
                        )}
                    </Consumer>
                </IconsContainer>
                <Details isEnabled={isEnabled}>
                    <Text>
                        <div>{whenText}</div>
                        <div>{thenText}</div>
                    </Text>
                    <ControlPanel>
                        <ControlPanelToggleButton>
                            <ToggleButton isOn={isEnabled} onChange={toggleRecipeStatus} />
                        </ControlPanelToggleButton>
                        <ControlPanelIcon icon={SCHEDULE} isDisabled={!isScheduled} onClick={showSchedule} />
                        <ControlPanelIcon icon={EDIT} onClick={editRecipe} />
                        <ControlPanelIcon icon={TRASH} onClick={deleteRecipe} />
                    </ControlPanel>
                </Details>
                <Overlay show={[UPDATING, CONFIRMING, DELETING].includes(status)}>
                    {status === UPDATING && <OverlayContent>{formatMessage(messages.updating)}</OverlayContent>}
                    {[CONFIRMING, DELETING].includes(status) && (
                        <OverlayContent>
                            <span>
                                {formatMessage(status === CONFIRMING ? messages.confirmDeleting : messages.deleting)}
                            </span>
                            <div>
                                {status === CONFIRMING && (
                                    <Button alternate onClick={cancelAction}>
                                        {formatMessage(messages.cancel)}
                                    </Button>
                                )}
                                {status === CONFIRMING && (
                                    <Button onClick={confirmDelete}>{formatMessage(messages.confirm)}</Button>
                                )}
                            </div>
                        </OverlayContent>
                    )}
                </Overlay>
            </Content>
        </RecipeItem>
    );
}

export default injectIntl(RecipesItem);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-item/component.js